const appdir = window.location.hostname.substr(0, window.location.hostname.indexOf('.'));
const urlid = window.location.href.split('/')[5];

const fetchExhibFloorConfig = () => {
   return new Promise((resolve, reject) => {
      let result = fetch(`https://masterapp.econference.io/masterapp_summer2012/controllers/mobileapp/settings/process_v2.cfm?urlid=${urlid}&appdir=${appdir}`)
      .then(res=>res.json())
      resolve(result)
   })
}


const fetchCompanyDetails = (info) => {
   return new Promise((resolve, reject) => {
      let result = fetch(`https://masterapp.econference.io/masterapp_summer2012/apiv2/index.cfm?appdir=${appdir}&module=company&component=exhibitor_directory&function=exhib_directory_app&conferenceid=${info.conferenceid}`, {
         body: JSON.stringify({ ConfID: info.confid }),
         method: "POST"
      })
         .then(res => res.json())
      resolve(result)
   })
}

const fetchTagsDetails = (info) => {
   let catids = (info?.exhibitor_hall_config?.main_hall_config?.directory_display_config?.tag_catids ?? []);
   return new Promise((resolve, reject) => {
      let result = {};
      if(catids && catids.length){
         result = fetch(`https://bm6uvz69il.execute-api.us-east-1.amazonaws.com/dev/api?module=client&component=tags&function=see_tags&appdir=${info.appdir}&catid=${catids.join()}`)
         .then(res=>res.json())
      }
      resolve(result)
   })
}

const fetchBoothConfigurations = (info) => {
   const {api_url, source_hex, ConfID} = info;
   let sending_data = {
      ConfID: ConfID
   };
   return new Promise((resolve, reject) => {
      let result = fetch(api_url + "?method=getConfiguration&returnFormat=json&Source=" + source_hex, {
         body: JSON.stringify(sending_data),
         method: "POST"
      }).then(res=>res.json())
      resolve(result)
   })
}

const exhibFloorAPI = {
   fetchExhibFloorConfig,
   fetchCompanyDetails,
   fetchTagsDetails,
   fetchBoothConfigurations
}
export default exhibFloorAPI
